import { Button } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { Link } from "react-router-dom";

const GUIDE_STEPS = [
  {
    step: "STEP 01",
    title: "핸드폰으로 대여·반납해요",
    description: "커뮤니티센터 사이트에서 ‘대여·반납’을 누르고 카메라 권한을 허용해 주세요.",
    image: "/images/hpoint-renewal/icons/book-barcode-menu-tap-guide-3d-v2-transparent.png",
    imageAlt: "커뮤니티센터 사이트에서 대여·반납 메뉴를 누르는 모습",
    accent: "purple",
  },
  {
    step: "STEP 02",
    title: "책 뒷면 바코드를 찾아요",
    description: "책 뒷면의 검은 세로줄 전체를 초록색 인식 틀 안에 가로로 맞추고 잠시 멈춰주세요.",
    image: "/images/hpoint-renewal/icons/book-barcode-scan-guide-3d-v1.png",
    imageAlt: "핸드폰 카메라로 책 뒷면 바코드를 인식하는 모습",
    accent: "lime",
  },
  {
    step: "STEP 03",
    title: "대여 현황을 확인해요",
    description: "나의 대여 도서와 반납일까지 남은 기간, 전체 대여 현황과 인기 도서를 실시간으로 확인할 수 있어요.",
    note: "대여 기록이 자동으로 통계화되어 많은 입주민이 참여할수록 작은 도서관이 더욱 풍성해집니다.",
    image: "/images/hpoint-renewal/icons/book-loan-statistics-guide-3d-v1-transparent.png",
    imageAlt: "도서 대여 현황과 통계를 확인하는 모습",
    accent: "blue",
  },
] as const;

const MobileBookGuide = () => (
  <main className="hpoint-renewal hp-book-guide-page">
    <section className="hp-book-guide-hero" aria-labelledby="book-guide-title">
      <span>작은 도서관 이용안내</span>
      <h1 id="book-guide-title">대여 및 반납 안내</h1>
      <p>책 뒷면 바코드를 핸드폰으로 비추면 기다리지 않고 간편하게 이용할 수 있어요.</p>
    </section>

    <section className="hp-book-guide-steps" aria-label="도서 대여와 반납 방법">
      {GUIDE_STEPS.map((item, index) => {
        const titleId = `book-guide-step-${index + 1}`;
        return (
          <article
            className={`hp-book-guide-step hp-book-guide-step--${item.accent}`}
            aria-labelledby={titleId}
            key={item.step}
          >
            <div className="hp-book-guide-step__copy">
              <span>{item.step}</span>
              <h2 id={titleId}>{item.title}</h2>
              <p>{item.description}</p>
              {"note" in item ? <strong>{item.note}</strong> : null}
            </div>
            <div className="hp-book-guide-step__visual">
              <img src={item.image} alt={item.imageAlt} />
            </div>
          </article>
        );
      })}
    </section>

    <aside className="hp-book-guide-fallback" aria-label="핸드폰 미지참 안내">
      <span aria-hidden="true">!</span>
      <p>
        <strong>핸드폰을 가져오지 않았나요?</strong>
        핸드폰을 가져오지 않은 경우 기존처럼 종이에 작성해 주세요. 관리소에서 확인 후 대리 등록할 예정입니다.
      </p>
    </aside>

    <section className="hp-book-guide-actions" aria-label="도서 서비스 바로가기">
      <Button
        className="hp-button hp-button--primary"
        component={Link}
        to="/mobilebookscan"
        endIcon={<ArrowForwardRoundedIcon />}
      >
        대여·반납 시작하기
      </Button>
      <Button
        className="hp-button hp-button--secondary"
        component={Link}
        to="/mobilebookstats"
        endIcon={<ArrowForwardRoundedIcon />}
      >
        대여 현황 보기
      </Button>
    </section>
  </main>
);

export default MobileBookGuide;
